/**
 * Created by cc on 2016/9/28 0028.
 */
export default  {
    deleteFlow: 'DELETE FROM f_action WHERE from_node_id IN (SELECT node_id FROM f_node WHERE flow_id = :flow_id);DELETE FROM f_node WHERE flow_id = :flow_id;DELETE FROM f_flow WHERE flow_id = :flow_id',
    updateFlowState: 'UPDATE f_flow SET flow_valid = :flow_valid ',

    insertFlow: 'INSERT INTO f_flow SET :flow',
    insertNode: 'INSERT INTO f_node SET :node',
    insertAction: 'INSERT INTO f_action SET :action',
    insertRecord : 'INSERT INTO f_action_record SET :record',

    insertInstance : 'INSERT INTO f_instance SET :instance',
    updateInstance : 'UPDATE f_instance SET :instance WHERE instance_id = :instance_id',


    getFlowSimplyInfo: 'SELECT flow_id,flow_code,flow_name,app_name,flow_valid,flow_version,flow_comment FROM f_flow',
    getFlowCount: 'SELECT COUNT(1) t FROM f_flow',
    getMaxVersionByCode : 'SELECT MAX(flow_version) t FROM f_flow WHERE flow_code = :flow_code',
    getFlow: 'SELECT flow_id,flow_code,flow_name,flow_struct,app_name,flow_valid,flow_version,flow_comment FROM f_flow',

    getInstanceSimplyInfo : 'SELECT * FROM f_instance',
    getInstanceCount : 'SELECT COUNT(1) t FROM f_instance',



    getNodeSimplyInfo : 'SELECT node_id,node_code,node_name,node_state,node_userid,node_allow_discard,node_allow_goback,node_type,controller_md5,page_md5,node_allow_save,node_allow_del,controller_save_md5,controller_del_md5 FROM f_node',
    getNodePage : 'SELECT page FROM f_node',
    getNodeController : 'SELECT controller FROM f_node',
    getNodeControllerSave : 'SELECT controller_save controller FROM f_node',
    getNodePageSave : 'SELECT page_save page FROM f_node',
    getNodeControllerDel : 'SELECT controller_del controller FROM f_node',
    getNodeForAutoNode : 'SELECT node_code FROM f_node WHERE node_id IN (SELECT to_node_id FROM f_action WHERE from_node_id = :node_id)',

    getActionSimplyInfo: 'SELECT action_id,action_code,action_name,action_type,controller_md5,page_md5,from_node_id,to_node_id FROM f_action',
    getActionController : 'SELECT controller FROM f_action',
    getActionPage : 'SELECT page FROM f_action',

    delInstanceByFlowid : 'DELETE FROM f_action_record WHERE instance_id IN (SELECT instance_id FROM f_instance WHERE flow_id = :flow_id);DELETE FROM f_instance WHERE flow_id = :flow_id;',
    delInstanceByInstanceid : 'DELETE FROM f_action_record WHERE instance_id = :instance_id ;DELETE FROM f_instance WHERE instance_id = :instance_id;',

    getRecord : [
        'SELECT a.*,b.action_name,b.action_code,b.action_type FROM f_action_record a ',
        ' INNER JOIN ( ',
        ' SELECT action_id,action_name,action_code,action_type FROM f_action ',
        ' UNION ',
        ' SELECT \'goback\',\'回退\',\'goback\',9 ',
        ' UNION ',
        ' SELECT \'discard\',\'废弃\',\'discard\',99 ',
        ' UNION ',
        ' SELECT \'undiscard\',\'还原\',\'undiscard\',98 ',
        ' ) b ON a.action_id = b.action_id '
    ].join('\n')
}
module.exports = exports.default;